{
  "name": "arson-lora",
  "version": "6.20",
  "license": "Proprietary",
  "scripts": {
    "ng": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng",
    "format": "prettier --write \"**/*.{ts,js,json,html,scss,css,md}\"",
    "start": "npm run ng -- serve",
    "start:container": "npm run ng -- serve --host 0.0.0.0",
    "build": "npm run ng -- build",
    "test": "npm run ng -- test --watch=false",
    "test:watch": "npm run ng -- test",
    "train:chatbot": "node scripts/train-chatbot.js",
    "chatbot:screens": "node scripts/check-chatbot-screens.js",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "e2e:report": "playwright show-report",
    "doc": "compodoc --serve",
    "doc:build": "compodoc"
  },
  "private": true,
  "dependencies": {
    "@angular-slider/ngx-slider": "^22.0.0",
    "@angular/cdk": "^22.2.0",
    "@angular/common": "^22.2.0",
    "@angular/compiler": "^22.2.0",
    "@angular/core": "^22.2.0",
    "@angular/forms": "^22.2.0",
    "@angular/localize": "^22.2.0",
    "@angular/material": "^22.2.0",
    "@angular/platform-browser": "^22.2.0",
    "@angular/platform-server": "^22.2.0",
    "@angular/router": "^22.2.0",
    "@angular/service-worker": "^22.2.0",
    "@bluehalo/ngx-leaflet": "^22.0.0",
    "@bluehalo/ngx-leaflet-draw": "^22.0.0",
    "@bluehalo/ngx-leaflet-markercluster": "^22.0.0",
    "@deck.gl/aggregation-layers": "9.4.0",
    "@deck.gl/core": "9.4.0",
    "@deck.gl/layers": "9.4.0",
    "@deck.gl/maplibre": "9.4.0",
    "@fortawesome/fontawesome-free": "^6.5.2",
    "@geoman-io/leaflet-geoman-free": "^2.17.0",
    "@ngx-translate/core": "^14.0.0",
    "@nlpjs/nlp": "^5.0.0-alpha.5",
    "@runette/leaflet-fullscreen": "^1.0.6",
    "@runette/ngx-leaflet-fullscreen": "^1.0.7",
    "@turf/turf": "^6.5.0",
    "@wlucha/ng-country-select": "^5.0.0",
    "@zxing/browser": "^0.2.1",
    "@zxing/ngx-scanner": "^22.0.1",
    "angular-resizable-element": "^7.0.2",
    "arima": "^0.2.5",
    "bn-ng-idle": "^2.0.5",
    "bootstrap": "^5.3.8",
    "buffer": "^6.0.3",
    "compute-cosine-similarity": "^1.1.0",
    "core-js": "^3.37.1",
    "cron-expression-validator": "^1.0.20",
    "crypto-js": "^4.2.0",
    "curve-matcher": "^1.1.1",
    "dayjs": "^1.11.13",
    "dompurify": "^3.4.17",
    "file-saver": "^2.0.5",
    "flag-icons": "^7.5.0",
    "font-awesome": "^4.7.0",
    "highcharts": "^11.4.1",
    "highcharts-angular": "^3.1.2",
    "html2pdf.js": "^0.14.0",
    "jspdf": "^4.2.0",
    "jszip": "^3.10.1",
    "leader-line": "^1.0.8",
    "leaflet": "^1.9.4",
    "leaflet-ant-path": "1.3",
    "leaflet-draw": "^1.0.4",
    "leaflet-edgebuffer": "^1.0.6",
    "leaflet-geosearch": "^4.0.0",
    "leaflet-kmz": "^1.0.9",
    "leaflet.fullscreen": "^3.0.2",
    "leaflet.heat": "^0.2.0",
    "leaflet.markercluster": "^1.5.3",
    "leaflet.polylinemeasure": "^3.0.0",
    "leaflet.utm": "^1.0.0",
    "maplibre-gl": "^6.11.2",
    "mathjs": "13.0.3",
    "ngx-daterangepicker-material": "^22.4.1",
    "ngx-resize-observer": "^4.0.0",
    "ngx-spinner": "^22.0.1",
    "ngx-webcam": "^0.4.1",
    "outlier2": "^3.14.159265",
    "proj4leaflet": "^1.0.2",
    "rxjs": "^7.8.1",
    "s-h-esd": "^0.0.3",
    "secure-web-storage": "^1.0.2",
    "shpjs": "^5.0.2",
    "simple-statistics": "^7.8.3",
    "supercluster": "^8.0.1",
    "supports-color": "^7.2.0",
    "sweetalert2": "^11.22.4",
    "tslib": "^2.6.2",
    "tty": "npm:tty-browserify@^0.0.1",
    "util": "^0.12.5",
    "uuid": "^14.0.2",
    "vkbeautify": "^0.99.3",
    "zipcelx": "^1.6.2",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/core": "^22.2.0",
    "@angular/build": "^22.2.0",
    "@angular/cli": "^22.2.0",
    "@angular/compiler-cli": "^22.2.0",
    "@angular/language-service": "^22.2.0",
    "@compodoc/compodoc": "^2.0.0",
    "@playwright/test": "^1.59.1",
    "@types/crypto-js": "^4.2.2",
    "@types/google.maps": "^3.55.9",
    "@types/leaflet": "^1.9.20",
    "@types/leaflet-draw": "^1.0.11",
    "@types/leaflet.fullscreen": "^3.0.2",
    "@types/leaflet.heat": "^0.2.4",
    "@types/leaflet.markercluster": "^1.5.5",
    "@types/leaflet.polylinemeasure": "^1.0.4",
    "@types/leaflet.utm": "^0.0.4",
    "@types/node": "^24.12.2",
    "@types/proj4leaflet": "^1.0.10",
    "@types/shpjs": "^3.4.7",
    "@types/supercluster": "^7.1.3",
    "cloc": "^2.10.0-cloc",
    "jsdom": "^30.1.1",
    "less": "^4.2.0",
    "prettier": "^3.5.3",
    "typescript": "^6.0.0",
    "vitest": "^5.0.3"
  },
  "overrides": {
    "@angular/build": {
      "vite": "8.3.3"
    },
    "@loaders.gl/core": "^4.5.2",
    "@loaders.gl/compression": {
      "fflate": "^0.7.5"
    },
    "encoding-sniffer": "1.0.2",
    "image-size": "^2.0.4",
    "tmp": "^0.2.4",
    "glob": "^10.5.0"
  },
  "allowScripts": {
    "@parcel/watcher@2.6.0": true,
    "@vaadin/vaadin-usage-statistics@2.1.3": true,
    "core-js@3.51.0": true,
    "esbuild@0.28.2": true,
    "esbuild@0.27.7": true,
    "lmdb@3.5.6": true,
    "msgpackr-extract@3.0.4": true,
    "@compodoc/compodoc@1.2.1": true,
    "lib-r-math.js@1.0.86": true
  }
}
